import { render, staticRenderFns } from "./SignupForm.vue?vue&type=template&id=d44ec830&scoped=true&"
import script from "./SignupForm.vue?vue&type=script&lang=ts&"
export * from "./SignupForm.vue?vue&type=script&lang=ts&"
import style0 from "./SignupForm.vue?vue&type=style&index=0&id=d44ec830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44ec830",
  null
  
)

export default component.exports